// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k2-1";
export var messageSideRight = "_k2-2";
export var orderLookupBubbleContainer = "_k2-0";
export var submitButton = "_k2-3";